import React from 'react';

import styles from './GameTopic.scss';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';

const GameTopicGraphic = ({ gameSlug, id, topicId }) => {
  try {
    const graphic = require(`Static/images/topics/${gameSlug}/${id}.png`);
    return (
      <ConnectedFormattedImage
        className="GameTopic__graphic"
        src={graphic}
        altId={`${topicId}.title`}
      />
    );
  } catch (e) {
    // There are 6 brand colors and we’re going to choose one at random.
    return <div className="GameTopic__graphic" data-placeholder="true" />;
  }
};

const GameTopic = ({ id, gameSlug }) => {
  const topicId = `model.${gameSlug}.topics.${id}`;

  return (
    <div className="GameTopic">
      <GameTopicGraphic id={id} gameSlug={gameSlug} topicId={topicId} />
      <div className="GameTopic__copy">
        <div className="GameTopic__title">
          <ConnectedFormattedMessage id={`${topicId}.title`} />
        </div>
        <div className="GameTopic__grades">
          <ConnectedFormattedMessage id={`${topicId}.grades`} />
        </div>
        <p className="GameTopic__description">
          <ConnectedFormattedMessage id={`${topicId}.description`} />
        </p>
      </div>
    </div>
  );
};

export default GameTopic;
